<template>
  <div id="app" class="container">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <img :src="logo" alt="Logo" class="logo" />
        </a>
        <a style="padding-top: 0.5%; padding-right: 2%; font-weight: 500; font-size: large;">File Share Service</a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav" style="padding-top: 0.5%">
          <ul class="navbar-nav">
            <li class="nav-item">
              <router-link to="/upload" class="nav-link">Upload File</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/folder-tree" class="nav-link">Folder Tree</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/tokens" class="nav-link">Tokens</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      logo: require('@/assets/i3logo.png'), 
    };
  },
};
</script>

<style scoped>
.logo {
  height: 40px;
  margin-right: 15px; /* Увеличен отступ справа */
  margin-left: 5px; /* Добавлен отступ слева */
}
</style>

